import { FC } from 'react';
import { AddressType } from '../types';
import { getDisplayName } from '../utils';
import styles from './formats.module.scss';
interface EuropeanFormatAddressProps {
  isFullAddress?: boolean;
  address: AddressType;
  isAddressTypeDisplay?: boolean;
  translatedAddressType?: string;
}

export const EuropeanFormatAddress: FC<EuropeanFormatAddressProps> = ({
  isFullAddress,
  address,
  isAddressTypeDisplay,
  translatedAddressType
}) => {
  const {
    address1,
    address2,
    firstName,
    middleName,
    lastName,
    city,
    country,
    email,
    phone,
    state,
    zipCode
  } = address;
  const europeanZipCodeSpacing = zipCode && city ? ' ' : '';

  return (
    <div data-testid="address-european" className={styles['formats']}>
      {isAddressTypeDisplay && (
        <p className="cat-u-theme-typography-label mb-0" data-cs-encrypt>
          {translatedAddressType}
        </p>
      )}
      <p className="mb-0 exclude-global" data-cs-encrypt>
        {getDisplayName(firstName, middleName, lastName)}
      </p>
      {address1 && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {address1}
        </p>
      )}
      {address2 && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {address2}
        </p>
      )}
      {(city || zipCode) && (
        <p className="mb-0 exclude-global text-capitalize" data-cs-encrypt>
          {city}
          {europeanZipCodeSpacing}
          {zipCode}
        </p>
      )}
      {state && (
        <p className="mb-0 exclude-global text-capitalize" data-cs-encrypt>
          {state}
        </p>
      )}
      {country && (
        <p className="mb-0 exclude-global text-capitalize" data-cs-encrypt>
          {country}
        </p>
      )}
      {phone && isFullAddress && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {phone}
        </p>
      )}
      {email && isFullAddress && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {email}
        </p>
      )}
    </div>
  );
};
